import React from 'react';


const UserDashboard = () => {
  return (
    <div className="user-dashboard">
      <h1>User Dashboard</h1>
      <div className="dashboard-content">
        <p>Welcome to your Dashboard</p>
        {/* Aggiungi qui il contenuto del dashboard */}
      </div>
    </div>
  );
};

export default UserDashboard;